import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { IMAGES } from "@/lib/config";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    bag_message: "",
    bookshop_title: "",
    logo: null,
    hero_images: [],
    history_images: [],
    bag_image: null,
  });
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    api
      .getSettings()
      .then((data) => {
        setSettings(data);
        setLoaded(true);
      })
      .catch((err) => {
        console.error("settings load failed", err);
        setLoaded(true);
      });
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Only use config fallbacks if settings LOADED and admin hasn't uploaded anything.
  // While loading (loaded === false) return empty arrays/null so UI shows a neutral
  // placeholder instead of a foreign stock image.
  const resolved = {
    loaded,
    bagMessage:
      settings.bag_message ||
      "Hej prijatelji! Polako kreće nova školska godina — pripremimo se na vrijeme!",
    bookshopTitle: settings.bookshop_title || "Vrijeme je za novu školsku godinu!",
    logo: settings.logo || (loaded ? IMAGES.logo : null),
    hero: settings.hero_images?.length
      ? settings.hero_images
      : loaded
      ? IMAGES.hero
      : [],
    historyGallery: settings.history_images?.length
      ? settings.history_images
      : loaded
      ? IMAGES.historyGallery
      : [],
    bagMascot: settings.bag_image || (loaded ? IMAGES.bagMascot : null),
  };

  return (
    <SettingsContext.Provider value={{ settings, resolved, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
